'use client';

import React from 'react';
import {Link} from 'wouter'

export default function CTASection() {
  return (
    <>
      <style>{`
        @keyframes popSpin {
          0%   { transform: rotate(0deg) scale(1); }
          15%  { transform: rotate(180deg) scale(1.3); }
          30%  { transform: rotate(360deg) scale(1); }
          100% { transform: rotate(360deg) scale(1); }
        }

        .icon-anim {
          animation: popSpin 5s ease-in-out infinite;
          transform-origin: center;
        }

        .icon-anim-delayed {
          animation: popSpin 5s ease-in-out infinite;
          animation-delay: 2.5s;
          transform-origin: center;
        }
      `}</style>

      <section className="relative bg-transparent px-4 py-20  sm:px-6 lg:px-8">
        <div className="relative mx-auto xl:max-w-[85%] max-w-[92%]">
          <div className="relative rounded-[28px] bg-[#6A35E0] px-5 py-12 md:px-10 md:py-16 shadow-[8px_8px_0px_0px_#573D92]">

            {/* Green square icon - left side */}
            <div className="icon-anim absolute sm:-left-10 -left-4 sm:-bottom-4 -bottom-10 h-20 w-20 bg-[#059669] flex justify-center items-center shadow-[5.45px_5.45px_0px_0px_#000]">
              <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M45.8182 25.4545H29.0182L40.9818 37.4182L37.4182 40.9818L25.4545 29.0182V45.8182H20.3636V28.7636L8.4 40.7273L4.83636 37.1636L16.2909 25.4545H0V20.3636H16.8L4.83636 8.4L8.4 4.83636L20.3636 16.8V0H25.4545V16.2909L37.1636 4.58182L40.7273 8.4L28.7636 20.3636H45.8182V25.4545Z" fill="#F8FAFC"/>
              </svg>
            </div>

            {/* Yellow badge icon - right side */}
            <div className="icon-anim-delayed absolute sm:-right-6 -right-3 bottom-28 flex h-12 w-12 items-center justify-center bg-[#E1B840] shadow-[5.45px_5.45px_0px_0px_#000] text-sm">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.50097 12.5459H22.3237M9.50097 19.2722H18.6455M15.9123 30.6249C19.1091 30.6243 22.2187 29.5826 24.7708 27.6576C27.323 25.7326 29.1789 23.0289 30.0579 19.9553C30.9368 16.8818 30.7911 13.6056 29.6426 10.6223C28.4942 7.63895 26.4055 5.11071 23.6925 3.41993C20.9795 1.72915 17.7897 0.967791 14.6055 1.25099C11.4213 1.53419 8.41593 2.84655 6.04389 4.98959C3.67185 7.13263 2.06215 9.9898 1.45823 13.129C0.854322 16.2682 1.28904 19.5186 2.69665 22.3888C2.86847 22.7388 2.92574 23.1334 2.83824 23.512L1.54006 29.1374C1.50346 29.2953 1.50766 29.4599 1.55226 29.6157C1.59685 29.7715 1.68038 29.9134 1.79498 30.028C1.90957 30.1426 2.05145 30.2261 2.20725 30.2707C2.36305 30.3153 2.52764 30.3195 2.68551 30.2829L8.30937 28.9831C8.68908 28.9 9.08585 28.9506 9.43256 29.1263C11.4489 30.1165 13.666 30.6293 15.9123 30.6249Z" stroke="#F8FAFC" stroke-width="2.38636" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>

            {/* Content */}
            <div className="relative z-10 text-center">
              <h2 className="mb-5 sm:text-4xl text-3xl font-semibold text-[#faf8fc] lg:text-5xl font-primary">
                Ready to break the language barrier?
              </h2>

              <p className="mx-auto mb-10 max-w-lg text-sm text-[#faf8fc] font-primary sm:text-base">
                Join travelers and global communities chatting across languages — no sign-up, no friction, just conversation.
              </p>

              {/* Button */}
              <Link to='/app/welcome' className="inline-flex items-center gap-2 rounded-lg bg-[#FF803E] px-6 py-3 sm:mt-8 mt-6 font-semibold text-[#faf8fc] font-primary duration-200 hover:scale-105 transform shadow-[6px_6px_0px_0px_#DF3838] cursor-pointer sm:text-base text-sm">
                Get Started for Free
                <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.0322 2.03414L3.61013 1.00005M12.0322 2.03414L10.9981 10.4562M12.0322 2.03414L1.00002 10.6534" stroke="#F8FAFC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </Link>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}